module.exports = __webpack_public_path__ + "img/image20@2x.1b351abd.png";